import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import Form from "theme/components/atoms/Form/Form";
import SizeGuide from "theme/components/organisms/SizeGuide";
import RadioOption from "./RadioOption";
import OptionPicker from "./OptionPicker";
import { ErrorAlert } from "theme/components/molecules/Alert";

class Configurator extends Component {
  constructor() {
    super();
    this.onChangeOptions = this.onChangeOptions.bind(this);
    this.onChangeCustomOptions = this.onChangeCustomOptions.bind(this);
  }

  onChangeOptions() {
    const model = this.optionsForm.getModel();
    Object.keys(model)
      .filter((key) => typeof model[key] !== "undefined")
      .forEach((option) =>
        this.props.setOption(option, model[option].value || model[option])
      );
  }

  onChangeCustomOptions() {
    const model = this.customOptionsForm.getModel();
    Object.keys(model)
      .filter((key) => typeof model[key] !== "undefined")
      .forEach((option) =>
        this.props.setCustomOption(option, model[option].value || model[option])
      );
  }

  render() {
    let soonOutOfStock = false;
    Object.keys(this.props.selectedOptions).length > 0 &&
      this.props.options.map((option) => {
        let optionId = Object.keys(this.props.selectedOptions)[0];
        if (option.id === optionId) {
          option.values.map((value) => {
            if (value.value === this.props.selectedOptions[optionId]) {
              if (value.availableProducts[0]?.stock.qty <= 5) {
                soonOutOfStock = true;
              }
            }
            return false;
          });
        }
        return false;
      });

    const customOptions = this.props.customOptions.map((option) => {
      return (
        option.type === "radio" && (
          <RadioOption
            key={option.option_id}
            required={option.is_required}
            {...option}
          />
        )
      );
    });
    const optionsPickers = this.props.options.map((option, index) => {
      return (
        <OptionPicker
          key={index}
          option={option}
          product={this.props.product}
          disabledOutOfStockOptions={this.props.disabledOutOfStockOptions}
        />
      );
    });

    return (
      <div className="configurator">
        <Form
          setRef={(form) => {
            this.optionsForm = form;
          }}
          onChange={this.onChangeOptions}
        >
          {optionsPickers}
        </Form>

        {soonOutOfStock && (
          <ErrorAlert>
            {this.props.intl.formatMessage({
              id: "components.organisms.Configurator.Configurator.warningStock",
              defaultMessage: "Few items left on stock",
            })}
          </ErrorAlert>
        )}
        {this.props.product.sizeGuide && (
          <SizeGuide
            sizeGuide={this.props.product.sizeGuide}
            attributeSetLabel={this.props.product.attributeSetLabel}
          />
        )}

        {customOptions && customOptions.length > 0 && (
          <Form
            setRef={(form) => {
              this.customOptionsForm = form;
            }}
            onChange={this.onChangeCustomOptions}
          >
            <div className="configurator__custom-options">{customOptions}</div>
          </Form>
        )}
      </div>
    );
  }
}

Configurator.propTypes = {
  options: PropTypes.array,
  initialOptions: PropTypes.object,
};

export default injectIntl(Configurator);
